<a xpo-regular-link [id]="id" (click)="openInNewWindow()">
    <xpo-icon iconName="open-in-new"></xpo-icon>{{label}}
</a>
